"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[452],{

/***/ 68276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ FollowAction; },
/* harmony export */   "Cx": function() { return /* binding */ TabAndShare; },
/* harmony export */   "Dg": function() { return /* binding */ ContanerWithBg; },
/* harmony export */   "E2": function() { return /* binding */ TabItem; },
/* harmony export */   "H_": function() { return /* binding */ BackgroundContainer; },
/* harmony export */   "M9": function() { return /* binding */ MainContent; },
/* harmony export */   "QU": function() { return /* binding */ CompanyAddress; },
/* harmony export */   "hV": function() { return /* binding */ MainBackgroundImage; },
/* harmony export */   "lk": function() { return /* binding */ TabAndShareWrapper; },
/* harmony export */   "o2": function() { return /* binding */ TabSectionWrapper; },
/* harmony export */   "qE": function() { return /* binding */ Avatar; },
/* harmony export */   "tJ": function() { return /* binding */ TabSection; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "zW": function() { return /* binding */ CompanyInfo; },
/* harmony export */   "zo": function() { return /* binding */ CompanyName; }
/* harmony export */ });
/* unused harmony export ShareSection */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18978);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            padding: 40px 32px 32px 32px;\n            @media screen and (max-width: 768px) {\n                padding: ",
        ";\n            }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            margin-top: 8px;\n            @media screen and (max-width: 768px) {\n                margin-top: 8px;\n            }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            position: fixed;\n            top: 0;\n            z-index: 10;\n            width: calc(100% - 32px);\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                border-radius: 0 0 6px 6px;\n            }\n            @media screen and (max-width: 991px) {\n                width: 100%;\n            }\n            @media screen and (min-width: 1200px) {\n                max-width: 1170px;\n                width: 1138px;\n            }\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            padding-bottom: 0 !important;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            @media screen and (max-width: 768px) {\n                background-color: transparent;\n                border: 0;\n                padding-top: 0 !important;\n            }\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    background-color: ",
        ";\n    border: ",
        ";\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: #fff;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    padding: 0 32px;\n    display: flex;\n    margin-bottom: 16px;\n    background-color: #fff;\n    @media (max-width: 768px) {\n        flex-direction: column;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: inline-block;\n    border-radius: 6px;\n    width: 136px;\n    height: 136px;\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n    position: relative;\n    overflow: hidden;\n    margin-top: -36.5px;\n    background-color: #fff;\n    z-index: 9;\n    @media (max-width: 768px) {\n        margin: -66px auto 0 auto;\n        width: 110px;\n        height: 110px;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    width: 100%;\n    padding-top: calc((510 / 1920) * 100%);\n    border-radius: 6px;\n    overflow: hidden;\n    @media (max-width: 768px) {\n        border-radius: 12px 12px 0 0;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    & > svg {\n        width: 100%;\n        background-image: linear-gradient(90deg, #005aff 47%, #001744 100%);\n    }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                display: none;\n            "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: inline-block;\n    vertical-align: top;\n    margin-left: 15px;\n    width: calc(100% - 400px);\n    @media (max-width: 768px) {\n        width: 100%;\n        margin: 0;\n        text-align: center;\n        ",
        "\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            display: ",
        ";\n            /* flex-direction: column; */\n            width: 100%;\n            padding-top: 16px;\n            span {\n                color: #777;\n                margin-bottom: 7px;\n            }\n            button {\n                width: 100%;\n            }\n        "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    align-content: center;\n    width: 262px;\n    padding-top: 24px;\n\n    span {\n        margin-right: 24px;\n    }\n\n    ",
        "\n    @media (max-width: 768px) {\n    }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    line-height: 26px;\n    margin: 24px 0 8px 0;\n    font-size: 24px;\n    color: #002c55;\n    @media (max-width: 768px) {\n        line-height: 24px;\n        margin: 24px auto 8px auto;\n    }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            margin-bottom: 0 !important;\n        "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            @media screen and (max-width: 768px) {\n                margin-top: 8px;\n                width: 100%;\n                text-align: center;\n            }\n        "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: #333;\n    font-size: 14px;\n    line-height: 16px;\n    margin: 0;\n    @media (max-width: 768px) {\n        margin-bottom: 24px;\n        line-height: 22px;\n    }\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-right: 12.5%;\n    &.sticky {\n        position: relative;\n        margin: 0 -24px;\n        width: calc(100% + 48px);\n    }\n    @media screen and (max-width: 768px) {\n        margin-right: 0;\n        margin-bottom: 16px;\n    }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    &.sticky {\n        position: fixed;\n        z-index: 199;\n        top: ",
        "px;\n        left: 0;\n        right: 0;\n        @media (min-width: 769px) {\n            padding: 0 16.5px;\n        }\n    }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: ",
        "px;\n    padding: 0 32px;\n    display: flex;\n    justify-content: space-between;\n    background-color: #fff;\n    &.sticky {\n        position: fixed;\n        z-index: 199;\n        padding: 0 56px;\n        box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);\n        border-bottom: 1px solid #e0e0e0;\n        top: ",
        "px;\n        border-radius: 0;\n        @media (min-width: 1200px) {\n            width: 1200px;\n        }\n    }\n    @media (max-width: 768px) {\n        width: 100% !important;\n        flex-direction: column-reverse;\n        padding: 0 24px;\n    }\n    @media (min-width: 992px) {\n        margin: 0 auto;\n    }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    @media (max-width: 768px) {\n        overflow-x: auto;\n        margin-top: 16px;\n        justify-content: center;\n        align-items: center;\n        &::-webkit-scrollbar {\n            display: none;\n        }\n    }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                display: none;\n            "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    ul {\n        display: flex;\n        list-style: none;\n        margin: 0;\n        li {\n            width: 24px;\n            height: 24px;\n            opacity: 0.4;\n            border-radius: 50%;\n            background-color: #d8d8d8;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            align-content: center;\n            margin-right: 8px;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n    span {\n        font-size: 14px;\n        line-height: 22px;\n        color: #333;\n    }\n    @media (max-width: 768px) {\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n        align-content: center;\n        margin-top: 20px;\n        ",
        "\n    }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            color: #005aff;\n            font-weight: 700;\n            border-bottom: 2px solid #005aff;\n        "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: #666;\n    font-size: 14px;\n    line-height: 23px;\n    font-weight: 500;\n    padding-bottom: 12px;\n    padding-top: 12px;\n    margin-right: 20px;\n    cursor: pointer;\n    ",
        "\n    &:last-child {\n        margin-right: 0;\n    }\n    &:hover {\n        color: #005aff;\n    }\n    @media (max-width: 768px) {\n        padding: 0 12px 12px 12px;\n        min-width: fit-content;\n    }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}


var ContentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ca95509a-0"
})(_templateObject5(), function(param) {
    var hasBg = param.hasBg;
    return hasBg ? "#fff" : "unset";
}, function(param) {
    var hasBorder = param.hasBorder;
    return hasBorder ? "1px solid rgba(51, 51, 51, 0.08)" : "unset";
}, function(param) {
    var isPadding = param.isPadding, disablePaddingMobile = param.disablePaddingMobile;
    if (!isPadding) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), disablePaddingMobile ? "0" : "12px");
}, function(param) {
    var isMarginTop = param.isMarginTop;
    if (!isMarginTop) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1());
}, function(param) {
    var isSticky = param.isSticky;
    if (!isSticky) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
}, function(param) {
    var noPaddingBottom = param.noPaddingBottom;
    if (!noPaddingBottom) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3());
}, function(param) {
    var isTransparentOnMobile = param.isTransparentOnMobile;
    if (!isTransparentOnMobile) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4());
});
var ContanerWithBg = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-1"
})(_templateObject6());
var MainContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-2"
})(_templateObject7());
var Avatar = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-3"
})(_templateObject8());
var BackgroundContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-4"
})(_templateObject9());
var MainBackgroundImage = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-5"
})(_templateObject10());
var CompanyInfo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-6"
})(_templateObject12(), function(param) {
    var isSticky = param.isSticky;
    if (!isSticky) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject11());
});
var FollowAction = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-7"
})(_templateObject14(), function(param) {
    var isMobile = param.isMobile, isSticky = param.isSticky;
    return isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject13(), isSticky ? "none" : "flex");
});
var CompanyName = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-ca95509a-8"
})(_templateObject15());
var CompanyAddress = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-ca95509a-9"
})(_templateObject18(), function(param) {
    var isNoMarginBottom = param.isNoMarginBottom;
    if (!isNoMarginBottom) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject16());
}, function(param) {
    var isCenter = param.isCenter;
    if (!isCenter) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject17());
});
var TabAndShareWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-10"
})(_templateObject19());
var TabAndShare = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-11"
})(_templateObject20(), function(param) {
    var offset = param.offset;
    return offset;
});
var TabSectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-12"
})(_templateObject21(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var width = param.width;
    return width;
});
var TabSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-13"
})(_templateObject22());
var ShareSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-14"
})(_templateObject24(), function(param) {
    var isSticky = param.isSticky;
    if (!isSticky) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject23());
});
var TabItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca95509a-15"
})(_templateObject26(), function(param) {
    var isSelected = param.isSelected;
    if (!isSelected) {
        return "";
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject25());
});


/***/ }),

/***/ 93070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_GotoTop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseElementOnScreen/index.js
var UseElementOnScreen = __webpack_require__(85694);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Icons/ArrowUpIcon/index.tsx


var ArrowUpIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fill: "#000000",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50",
        width: "20px",
        height: "20px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M 25 1.015625 L 14.308594 11.28125 C 14.046875 11.527344 13.9375 11.894531 14.023438 12.242188 C 14.109375 12.589844 14.375 12.867188 14.71875 12.964844 C 15.066406 13.066406 15.4375 12.972656 15.691406 12.71875 L 24 4.746094 L 24 48 C 23.996094 48.359375 24.183594 48.695313 24.496094 48.878906 C 24.808594 49.058594 25.191406 49.058594 25.503906 48.878906 C 25.816406 48.695313 26.003906 48.359375 26 48 L 26 4.746094 L 34.308594 12.71875 C 34.5625 12.972656 34.933594 13.066406 35.28125 12.964844 C 35.625 12.867188 35.890625 12.589844 35.976563 12.242188 C 36.0625 11.894531 35.953125 11.527344 35.691406 11.28125 Z"
        })
    });
};
/* harmony default export */ var Icons_ArrowUpIcon = (/*#__PURE__*/(0,react.memo)(ArrowUpIcon));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(67430);
;// CONCATENATED MODULE: ./components/GotoTop/GotoTop.css.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    bottom: 100px;\n    right: 33px;\n    z-index: 100;\n    width: 36px;\n    height: 36px;\n    border-radius: 20px;\n    cursor: pointer;\n    transition: all 0.25s ease-in-out;\n    visibility: ",
        ";\n    opacity: ",
        ";\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    background: white;\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 10px 0px;\n    @media screen and (max-width: ",
        "px) {\n        bottom: 170px;\n        right: 22px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GotoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1674c463-0"
})(_templateObject(), function(param) {
    var isShow = param.isShow;
    return isShow ? "visible" : "hidden";
}, function(param) {
    var isShow = param.isShow;
    return isShow ? 1 : 0;
}, responsiveHelper/* screens.mobile */.FB.mobile);

;// CONCATENATED MODULE: ./components/GotoTop/index.tsx






var GotoTop = function(props) {
    var trackId = props.trackId;
    var ref = (0,react.useState)(false), isShow = ref[0], setShow = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(UseElementOnScreen/* default */.Z({
        target:  true ? document.getElementById(trackId) : 0,
        options: {
            threshold: 0.1,
            isUseReactRef: false
        }
    }), 1), isOnTop = ref1[0];
    var handleOnClick = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        var scrollY = window.scrollY;
        if (scrollY > 50) {
            setShow(!isOnTop);
        } else {
            setShow(false);
        }
    }, [
        isOnTop
    ]);
    return isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GotoWrapper, {
        isShow: true,
        onClick: handleOnClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowUpIcon, {})
    }) : null;
};
/* harmony default export */ var components_GotoTop = (GotoTop);


/***/ }),

/***/ 9741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MasterLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/dist/index.modern.js
var index_modern = __webpack_require__(64889);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Container/index.js
var Container = __webpack_require__(91461);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/encode.ts
var encode = __webpack_require__(68325);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js
var helpers = __webpack_require__(55613);
;// CONCATENATED MODULE: ./services/userService.ts







var UserService = /*#__PURE__*/ function() {
    "use strict";
    function UserService() {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, UserService);
        this._userResolver = null;
        this._user = new Promise(function(resolve) {
            _this._userResolver = resolve;
        });
    }
    var _proto = UserService.prototype;
    _proto.setUser = function setUser(user) {
        this._userResolver && this._userResolver(user);
    };
    /**
     * This will return a user promise, and will resolve to `TAuthUser` or `null` if user has not signed in
     */ _proto.getUser = function getUser() {
        return this._user;
    };
    _proto.getAccessToken = function getAccessToken() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var user;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.getUser()
                        ];
                    case 1:
                        user = _state.sent();
                        if (user === null) {
                            return [
                                2,
                                ""
                            ];
                        }
                        return [
                            2,
                            (user === null || user === void 0 ? void 0 : user.accessToken) || ""
                        ];
                }
            });
        })();
    };
    /**
     * This method is called once in Master Layout when the component mounted
     */ _proto.authenticate = function authenticate(jsToken, wsToken) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var response, _tmp, responseData, singleData, user, _tmp1, _tmp2, ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        _tmp = {};
                        return [
                            4,
                            fetch("https://secure.vietnamworks.com/api/v1/users/get-info-from-token", (_tmp.method = "post", _tmp.headers = {
                                "Content-Type": "application/vnd.api+json",
                                Accept: "application/vnd.api+json"
                            }, _tmp.body = JSON.stringify({
                                jsToken: jsToken,
                                wsToken: wsToken
                            }), _tmp))
                        ];
                    case 1:
                        response = _state.sent();
                        if (!(response.status === 200)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        responseData = _state.sent();
                        singleData = responseData.data[0];
                        _tmp1 = {};
                        _tmp2 = {};
                        user = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, singleData.id, singleData.attributes), (_tmp2.accessToken = helpers/* encrypt */.HI(singleData.attributes.accessToken), _tmp2));
                        _this.setUser(user);
                        return [
                            2,
                            user
                        ];
                    case 3:
                        // If fail
                        _this.setUser(null);
                        return [
                            2,
                            null
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        ex = _state.sent();
                        esm/* captureException */.Tb(ex);
                        return [
                            2,
                            null
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return UserService;
}();
/* harmony default export */ var userService = (new UserService());

// EXTERNAL MODULE: ./store/index.tsx + 1 modules
var store = __webpack_require__(13448);
// EXTERNAL MODULE: ./store/actions.ts
var actions = __webpack_require__(47806);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/utmTracking.js
var utmTracking = __webpack_require__(17804);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./helpers/common.ts + 3 modules
var common = __webpack_require__(3298);
;// CONCATENATED MODULE: ./components/MetaTags/translations.ts
var translations = {
    "companies": "nha-tuyen-dung",
    "company-list": "danh-sach-cong-ty"
};
/* harmony default export */ var MetaTags_translations = (translations);

;// CONCATENATED MODULE: ./components/MetaTags/index.tsx









var OG_IMAGE = "".concat("https://images.vietnamworks.com", "/images/vnw_empower_growth_logo.png?v=").concat("1");
var JS_BASE_URL = "https://www.vietnamworks.com";
var VNW_LOGO = "".concat(JS_BASE_URL, "/assets-page-container/images/vnw_empower_growth_logo.png");
var MetaTags = function(props) {
    var _description = props.description, description = _description === void 0 ? "Search for jobs hiring using our Job Search. Thousands of jobs in different field in Vietnam. Find your dream jobs and apply with just 1 click now!" : _description, _ogImageUrl = props.ogImageUrl, ogImageUrl = _ogImageUrl === void 0 ? OG_IMAGE : _ogImageUrl, _pageName = props.pageName, pageName = _pageName === void 0 ? "" : _pageName, metaHead = props.metaHead, language = props.language;
    var _state = (0,store.useStore)().state, t = _state.t, langCode = _state.langCode;
    var router = (0,next_router.useRouter)();
    var translate = function(key) {
        return MetaTags_translations[key] || key;
    };
    var pathSplit = router.asPath.split("/");
    for(var idx = 0; idx < pathSplit.length; idx++){
        pathSplit[idx] = translate(pathSplit[idx]);
    }
    var currentUrl = (0,common/* getPathFromUrl */.jb)("".concat(JS_BASE_URL).concat(pathSplit.join("/")));
    var favicon = "".concat(JS_BASE_URL, "/favicon.ico?v=").concat("1");
    var titleText = (metaHead === null || metaHead === void 0 ? void 0 : metaHead.title) || "".concat(t("meta_title"), " | VietnamWorks");
    var descriptionText = (metaHead === null || metaHead === void 0 ? void 0 : metaHead.description) || t("meta_description");
    var canonicalUrl = (metaHead === null || metaHead === void 0 ? void 0 : metaHead.canonicalUrl) || (0,utmTracking/* formatCanonicalUrl */.zv)(currentUrl);
    var twitterImageUID = Date.now().toString(36);
    var robotsContent = (metaHead === null || metaHead === void 0 ? void 0 : metaHead.robots) || "index, follow";
    if (router.asPath.indexOf("?") > 0) {
        robotsContent = "noindex, nofollow";
    }
    if (language === constants/* ELanguage.EN */.Df.EN) {
        robotsContent = "noindex, nofollow";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: titleText
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut icon",
                        href: favicon,
                        type: "image/x-icon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: descriptionText
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: Colors/* colors.primary.20 */.O9.primary[20]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: robotsContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: currentUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: titleText
                    }, "ogTitle"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: descriptionText
                    }, "ogDescription"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: currentUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: titleText
                    }, "twitterTitle"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: descriptionText
                    }, "twitterDescription"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: ogImageUrl + "?".concat(twitterImageUID)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image:src",
                        content: ogImageUrl + "?".concat(twitterImageUID)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: ogImageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: ogImageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: "526"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: "275"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://google.com.vn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://googleads.g.doubleclick.net"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://www.googletagmanager.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://www.google-analytics.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://stats.g.doubleclick.net"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://www.google.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://connect.facebook.net"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://www.facebook.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://www.googleadservices.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://images.vietnamworks.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: VNW_LOGO
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "ga",
                dangerouslySetInnerHTML: {
                    __html: "\n                    var _gaq = _gaq || [];\n                    var pluginUrl = '//www.google-analytics.com/plugins/ga/inpage_linkid.js';\n                    _gaq.push(['_require', 'inpage_linkid', pluginUrl]);\n                    _gaq.push(['_setAccount', '".concat("UA-103236-1", "']);\n                    _gaq.push(['_setDomainName', '").concat("vietnamworks.com", "']);\n                    _gaq.push(['_trackPageview']);\n\n                    (function() {\n                        var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;\n                        ga.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'stats.g.doubleclick.net/dc.js';\n                        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);\n                    })();\n                    function customEvent (uniqueName, action, label, value) {\n                        if (_gaq) {\n                            _gaq.push(['_trackEvent', uniqueName, action, label], value || 1); // 'Videos', 'Play', 'First Birthday'\n                        }\n                    }")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gtm",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','".concat("GTM-TKNN69", "');")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "".concat("https://www.vietnamworks.com/companies", "assets-page-container/js/jquery.min.js")
            })
        ]
    });
};
/* harmony default export */ var components_MetaTags = (MetaTags);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseInitNotification/index.js
var UseInitNotification = __webpack_require__(72831);
;// CONCATENATED MODULE: ./components/Notification/index.tsx
/* provided dependency */ var process = __webpack_require__(83454);



var DynamicNotification = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 71567)).then(function(mod) {
    return mod.Notifications;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71567)
            ];
        }
    },
    ssr: false
});
function NotificationComponent(props) {
    UseInitNotification/* useInitNotification */.U();
    var _MICROSERVICE_DOMAIN;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicNotification, {
        langCode: props.langCode,
        user: props.user,
        config: {
            firebaseConfig: props.firebaseConfig,
            jobSeekerUrl: props.jobSeekerUrl,
            baseMsUrl: (_MICROSERVICE_DOMAIN = process.env.MICROSERVICE_DOMAIN) !== null && _MICROSERVICE_DOMAIN !== void 0 ? _MICROSERVICE_DOMAIN : ""
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/MasterLayout/MasterLayout.css.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0%,\n    20%,\n    80%,\n    100% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.5);\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 90vh;\n    background: white;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background-color: #f5f5f5;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 16px 16px 32px 16px;\n    ",
        "\n    ",
        "\n     @media (max-width: 768px) {\n        padding: 12px 12px 16px 12px;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: -12px;\n    margin-right: -12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n    padding: 0 8px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-basis: 100%;\n    margin-bottom: 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: linear-gradient(270deg, #005aff 0%, #001744 100%);\n    height: 90vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    z-index: 999;\n    width: 100%;\n    left: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n    > div {\n        position: absolute;\n        width: 6px;\n        height: 6px;\n        background: #fff;\n        border-radius: 50%;\n        animation: ",
        " 1.2s linear infinite;\n        &:nth-child(1) {\n            animation-delay: 0s;\n            top: 37px;\n            left: 66px;\n        }\n\n        &:nth-child(2) {\n            animation-delay: -0.1s;\n            top: 22px;\n            left: 62px;\n        }\n\n        &:nth-child(3) {\n            animation-delay: -0.2s;\n            top: 11px;\n            left: 52px;\n        }\n\n        &:nth-child(4) {\n            animation-delay: -0.3s;\n            top: 7px;\n            left: 37px;\n        }\n\n        &:nth-child(5) {\n            animation-delay: -0.4s;\n            top: 11px;\n            left: 22px;\n        }\n\n        &:nth-child(6) {\n            animation-delay: -0.5s;\n            top: 22px;\n            left: 11px;\n        }\n\n        &:nth-child(7) {\n            animation-delay: -0.6s;\n            top: 37px;\n            left: 7px;\n        }\n\n        &:nth-child(8) {\n            animation-delay: -0.7s;\n            top: 52px;\n            left: 11px;\n        }\n\n        &:nth-child(9) {\n            animation-delay: -0.8s;\n            top: 62px;\n            left: 22px;\n        }\n\n        &:nth-child(10) {\n            animation-delay: -0.9s;\n            top: 66px;\n            left: 37px;\n        }\n\n        &:nth-child(11) {\n            animation-delay: -1s;\n            top: 62px;\n            left: 52px;\n        }\n\n        &:nth-child(12) {\n            animation-delay: -1.1s;\n            top: 52px;\n            left: 62px;\n        }\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var MasterLayoutWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8802dd35-0"
})(_templateObject());
var ldsDefault = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var Placeholder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8802dd35-1"
})(_templateObject2());
var VContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8802dd35-2"
})(_templateObject4(), function(param) {
    var noPaddingResponsiveContainer = param.noPaddingResponsiveContainer;
    return noPaddingResponsiveContainer ? "\n            @media (max-width: 768px) {\n                padding: 0;\n            }\n        " : "";
}, function(param) {
    var isHaveBackground = param.isHaveBackground;
    if (!isHaveBackground) {
        return "";
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var VRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8802dd35-3"
})(_templateObject5());
var VCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8802dd35-4"
})(_templateObject6());
var MainColFull = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8802dd35-5"
})(_templateObject7());
var GlobalLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8802dd35-6"
})(_templateObject8());
var LoadingDefault = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8802dd35-7"
})(_templateObject9(), ldsDefault);

;// CONCATENATED MODULE: ./components/MasterLayout/index.tsx















var _NEXT_PUBLIC_FIREBASE_API_KEY, _NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN, _NEXT_PUBLIC_FIREBASE_DATABASE_URL;
var firebaseConfig = {
    apiKey: (_NEXT_PUBLIC_FIREBASE_API_KEY = "AIzaSyAJLgT_Xo5Jg_YyPaWYOrk5sFnAtEcOIfU") !== null && _NEXT_PUBLIC_FIREBASE_API_KEY !== void 0 ? _NEXT_PUBLIC_FIREBASE_API_KEY : "",
    authDomain: (_NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN = "vietnamworks-message.firebaseapp.com") !== null && _NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN !== void 0 ? _NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN : "",
    databaseURL: (_NEXT_PUBLIC_FIREBASE_DATABASE_URL = "https://vietnamworks-message.firebaseio.com") !== null && _NEXT_PUBLIC_FIREBASE_DATABASE_URL !== void 0 ? _NEXT_PUBLIC_FIREBASE_DATABASE_URL : "",
    refreshJWTUrl: "".concat("https://www.vietnamworks.com", "/my-career-center/employer-message/?action=renewFirebaseJWT")
};
var MIN_LOADING_MS = 400;
var isPassMinLoadingTime = false;
var FIXED_HEADER_HEIGHT = 74;
var PADDING_TOP_BOTTOM_NAV = 32;
var MasterLayout = function(props) {
    var children = props.children, _langCode = props.langCode, langCode = _langCode === void 0 ? constants/* ELanguage.VI */.Df.VI : _langCode, jsToken = props.jsToken, wsToken = props.wsToken, _companyName = props.companyName, companyName = _companyName === void 0 ? "" : _companyName, appMode = props.appMode, _noOffsetContainer = props.noOffsetContainer, noOffsetContainer = _noOffsetContainer === void 0 ? false : _noOffsetContainer, _noPaddingResponsiveContainer = props.noPaddingResponsiveContainer, noPaddingResponsiveContainer = _noPaddingResponsiveContainer === void 0 ? false : _noPaddingResponsiveContainer, metaHead = props.metaHead, seoKeywords = props.seoKeywords;
    var ref = (0,react.useState)(false), globalLoading = ref[0], setGlobalLoading = ref[1];
    var containerRef = (0,react.useRef)(null);
    var ref1 = (0,store.useStore)(), state = ref1.state, dispatch = ref1.dispatch;
    var user = state.user;
    // Authenticate
    var doAuthenticate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var user, setUserAndUserRelatedData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!jsToken || !wsToken) {
                            // setIsReady(true)
                            setGlobalLoading(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            userService.authenticate(jsToken, wsToken)
                        ];
                    case 1:
                        user = _state.sent();
                        if (user) {
                            setUserAndUserRelatedData = function(user) {
                                dispatch({
                                    type: actions/* ACTION_SET_USER */.gS,
                                    payload: user
                                });
                            };
                            if (isPassMinLoadingTime) {
                                setUserAndUserRelatedData(user);
                            } else {
                                setTimeout(function() {
                                    setUserAndUserRelatedData(user);
                                }, MIN_LOADING_MS);
                            }
                        }
                        // setIsReady(true)
                        setGlobalLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function doAuthenticate() {
            return _ref.apply(this, arguments);
        };
    }();
    var initSelectData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp, companyIndustries, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            index_modern/* initialDataProvider.initSelectData */.Bz.initSelectData((_tmp.selectDataKey = [
                                "industry",
                                "jobFunction",
                                "level"
                            ], _tmp.mode = "production", _tmp))
                        ];
                    case 1:
                        _state.sent();
                        companyIndustries = index_modern/* initialDataProvider.getIndustries */.Bz.getIndustries();
                        _tmp1 = {};
                        if (companyIndustries.length) {
                            dispatch((_tmp1.type = actions/* ACTION_SET_COMPANY_INDUSTRY_SELECTION */.r7, _tmp1.payload = companyIndustries, _tmp1));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function initSelectData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setGlobalLoading(true);
        // setMounted(true)
        doAuthenticate();
        initSelectData();
        setTimeout(function() {
            isPassMinLoadingTime = true;
        }, MIN_LOADING_MS);
        // Scroll to top
        window.scrollTo(0, 0);
        // Set current state to mobile/tablet
        dispatch({
            type: actions/* ACTION_SET_IS_MOBILE */.vQ,
            payload:  true ? window.innerWidth < 769 : 0
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        _addHotJarScript();
    }, []);
    (0,react.useEffect)(function() {
        if (globalLoading) {
            document.body.classList.add("noScroll");
            document.documentElement.classList.add("noScroll");
        } else {
            document.body.classList.remove("noScroll");
            document.documentElement.classList.remove("noScroll");
        }
    }, [
        globalLoading
    ]);
    var _NEXT_PUBLIC_VNW_JOBSEEKER_URL, ref2, _NEXT_PUBLIC_MS_BASE_PATH;
    var notificationProps = {
        langCode: langCode,
        firebaseConfig: firebaseConfig,
        jobSeekerUrl: (_NEXT_PUBLIC_VNW_JOBSEEKER_URL = "https://www.vietnamworks.com") !== null && _NEXT_PUBLIC_VNW_JOBSEEKER_URL !== void 0 ? _NEXT_PUBLIC_VNW_JOBSEEKER_URL : "",
        user: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            accessToken: (0,encode/* decrypt */.pe)((ref2 = user === null || user === void 0 ? void 0 : user.accessToken) !== null && ref2 !== void 0 ? ref2 : "")
        }),
        baseMsUrl: (_NEXT_PUBLIC_MS_BASE_PATH = "https://ms.vietnamworks.com") !== null && _NEXT_PUBLIC_MS_BASE_PATH !== void 0 ? _NEXT_PUBLIC_MS_BASE_PATH : ""
    };
    var _addScript = function(content, id, toHead) {
        var script = document.createElement("script");
        if (id) script.id = id;
        script.innerHTML = content;
        var idExists = document.getElementById(id || "");
        if (idExists === null) {
            if (toHead) {
                document.head.append(script);
            } else {
                if (document.body !== undefined) {
                    document.body.append(script);
                }
            }
        }
    };
    var _addHotJarScript = function() {
        var content = "(function(h,o,t,j,a,r){\n                        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n                        h._hjSettings={hjid:1632895,hjsv:6};\n                        a=o.getElementsByTagName('head')[0];\n                        r=o.createElement('script');r.defer=1;\n                        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n                        a.appendChild(r);\n                    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";
        return _addScript(content, "hotJar");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MasterLayoutWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MetaTags, {
                pageName: companyName,
                metaHead: metaHead,
                language: langCode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Header */.h4, {
                mode: appMode,
                langCode: langCode,
                user: user,
                pageName: index_modern/* EPages.COMPANY_LIST */.QS.COMPANY_LIST,
                responsive: {
                    type: "search-page",
                    cornerColor: "#F9F9Fa"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VContainer, {
                id: "main-vcontainer",
                ref: containerRef,
                noPaddingResponsiveContainer: noPaddingResponsiveContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    noOffset: noOffsetContainer,
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* default */.ZP, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationComponent, (0,_object_spread/* default */.Z)({}, notificationProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Footer */.$_, {
                mode: appMode,
                langCode: langCode,
                user: user,
                seoKeywordData: seoKeywords
            })
        ]
    });
};
/* harmony default export */ var components_MasterLayout = (MasterLayout);


/***/ }),

/***/ 68325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pe": function() { return /* binding */ decrypt; }
/* harmony export */ });
/* unused harmony exports encodeBase64, decodeBase64 */
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];
// due to deprecated of btoa, atob function
// export function encrypt(token: string): string {
//     return btoa(btoa(token)).replace(/=/g, '')
// }
// export function decrypt(token: string): string {
//     return atob(atob(token))
// }
// typescript prefer buffer
/**
 * Encode to base64
 * @param content : text need to encode
 * @returns encoded text in base64
 */ var encodeBase64 = function(content) {
    return Buffer.from(content).toString("base64").replace(/=/g, "");
};
/**
 * Decode text from base64
 * @param content : text need to decode
 * @returns decoded text from base64
 */ var decodeBase64 = function(content) {
    return Buffer.from(content, "base64").toString("ascii");
};
function decrypt(token) {
    if (typeof atob === "function") {
        return atob(atob(token));
    }
    var nodeAtob = function nodeAtob(str) {
        return Buffer.from(str, "base64").toString("binary");
    };
    return nodeAtob(nodeAtob(token));
}


/***/ }),

/***/ 19886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G_": function() { return /* binding */ companyDetailService; },
  "cP": function() { return /* binding */ companyFollow; }
});

// UNUSED EXPORTS: EBenefitName, getCompanyOCIInfoFromId

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./helpers/encode.ts
var encode = __webpack_require__(68325);
// EXTERNAL MODULE: ./services/jobService.ts
var jobService = __webpack_require__(10656);
;// CONCATENATED MODULE: ./helpers/urlHelper.ts
var TCompanyId;
(function(TCompanyId) {
    TCompanyId["COMPANY_ID"] = "companyId";
    TCompanyId["EMPLOYER_ID"] = "employerId";
})(TCompanyId || (TCompanyId = {}));
var getCompanyId = function(path) {
    var splittedPath = path.split("-");
    var type = splittedPath[splittedPath.length - 1][0];
    var id = splittedPath[splittedPath.length - 1].slice(1);
    return {
        type: type === "c" ? TCompanyId.COMPANY_ID : TCompanyId.EMPLOYER_ID,
        id: id
    };
};
var getInfoFromUrl = function(url) {
    var path = url;
    var params = "";
    var questionSplit = url.split("?");
    if (questionSplit.length === 2) {
        params = questionSplit[1];
        path = questionSplit[0];
    }
    var splittedPath = path.split("/");
    return {
        path: splittedPath[splittedPath.length - 1],
        params: params ? "?".concat(params) : ""
    };
};
var buildQueryString = function(params) {
    if (!params || typeof params !== "object") {
        return "";
    }
    var queryString = Object.keys(params).map(function(key) {
        var encodedKey = encodeURIComponent(key);
        var encodedValue = encodeURIComponent(params[key]);
        return "".concat(encodedKey, "=").concat(encodedValue);
    }).join("&");
    return queryString;
};

;// CONCATENATED MODULE: ./services/companyDetailService.ts







var COMPANY_DETAIL_API = (/* unused pure expression or super */ null && ("https://ms.vietnamworks.com" + "/company-profile/v1.0/company-profile/detail"));
var COMPANY_OCI_API = "https://ms.vietnamworks.com" + "/company-profile/v1.0/oci";
var COMPANY_DETAIL_API_V2 = "https://ms.vietnamworks.com" + "/company-profile/v1.0/company-info";
var COMPANY_FOLLOW_API = "".concat("https://ms.vietnamworks.com", "/api-gateway/v1.0/profile/follow");
var EBenefitName;
(function(EBenefitName) {
    EBenefitName["Bonus"] = "Bonus";
    EBenefitName["HealthcarePlan"] = "Healthcare Plan";
    EBenefitName["PaidLeave"] = "Paid Leave";
    EBenefitName["Training"] = "Training";
    EBenefitName["Awards"] = "Awards";
    EBenefitName["Library"] = "Library";
    EBenefitName["Mobile"] = "Mobile";
    EBenefitName["TravelOpportunities"] = "Travel Opportunities";
    EBenefitName["TeamActivities"] = "Team Activities";
    EBenefitName["Transportation"] = "Transportation";
    EBenefitName["Canteen"] = "Canteen";
    EBenefitName["Vochers"] = "Vochers";
    EBenefitName["Kindergarten"] = "Kindergarten";
    EBenefitName["Others"] = "Others";
})(EBenefitName || (EBenefitName = {}));
var getCompanyOCIInfoFromId = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId, langCode) {
        var response, _tmp, json, data, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!companyId) {
                        return [
                            2,
                            null
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch("".concat(COMPANY_OCI_API, "/").concat(companyId, "?profilePublishedSiteMask=1"), (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "application/json",
                            "Accept-Language": langCode || constants/* ELanguage.VI */.Df.VI
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    json = _state.sent();
                    data = json.data;
                    if (!data.attributes.coProfileId) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        data.attributes
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCompanyOCIInfoFromId(companyId, langCode) {
        return _ref.apply(this, arguments);
    };
}();
var companyDetailService = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data, userId, langCode) {
        var requestOptions, _tmp, url, responseCompanyDetail, responseCompany, err, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    requestOptions = (_tmp.method = "GET", _tmp.headers = {
                        "Content-Type": "application/json",
                        "Accept-Language": langCode || constants/* ELanguage.VI */.Df.VI
                    }, _tmp);
                    langCode = langCode || constants/* ELanguage.VI */.Df.VI;
                    url = COMPANY_DETAIL_API_V2 + "?companyId=".concat(data.id, "&languageCode=").concat(langCode, "&userId=").concat(userId);
                    if (data.type === TCompanyId.EMPLOYER_ID) {
                        url = COMPANY_DETAIL_API_V2 + "?employerId=".concat(data.id, "&languageCode=").concat(langCode, "&userId=").concat(userId);
                    }
                    return [
                        4,
                        fetch(url, requestOptions)
                    ];
                case 1:
                    responseCompanyDetail = _state.sent();
                    return [
                        4,
                        responseCompanyDetail.json()
                    ];
                case 2:
                    responseCompany = _state.sent();
                    responseCompany.data = formatCompanyDetail(responseCompany.data);
                    return [
                        2,
                        responseCompany
                    ];
                case 3:
                    err = _state.sent();
                    esm/* captureException */.Tb(err);
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.meta = {
                            code: jobService/* DEFAULT_ERROR_CODE */.mk,
                            message: "ERROR"
                        }, _tmp1.data = null, _tmp1)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function companyDetailService(data, userId, langCode) {
        return _ref.apply(this, arguments);
    };
}();
var companyFollow = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(companyId, isFollow, accessToken, langCode) {
        var postData, _tmp, decodeToken, requestOptions, _tmp1, response, err, _tmp2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    postData = (_tmp.companyId = companyId, _tmp.status = isFollow ? 1 : 0, _tmp);
                    decodeToken = (0,encode/* decrypt */.pe)(accessToken);
                    _tmp1 = {};
                    requestOptions = (_tmp1.method = "POST", _tmp1.headers = {
                        "Content-Type": "application/json",
                        "Accept-Language": langCode || constants/* ELanguage.VI */.Df.VI,
                        Authorization: "Bearer ".concat(decodeToken)
                    }, _tmp1.body = JSON.stringify(postData), _tmp1);
                    return [
                        4,
                        fetch(COMPANY_FOLLOW_API, requestOptions)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    err = _state.sent();
                    esm/* captureException */.Tb(err);
                    _tmp2 = {};
                    return [
                        2,
                        (_tmp2.meta = {
                            code: jobService/* DEFAULT_ERROR_CODE */.mk,
                            message: "ERROR"
                        }, _tmp2.data = null, _tmp2)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function companyFollow(companyId, isFollow, accessToken, langCode) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * VNW-22972 [Web][Company detail] Change source to General info
 * Format detail to ICompanyInfo for rendering on client
 *
 * @param companyDetail
 * @return ICompanyInfo
 *
 * @author NPMHieu
 * @since Jul 4 2023
 */ var formatCompanyDetail = function formatCompanyDetail(companyData) {
    var attributes = companyData.attributes;
    var industryNames = "";
    var industries = [];
    if (attributes.industries && Array.isArray(attributes.industries)) {
        var ref, ref1;
        industryNames = attributes === null || attributes === void 0 ? void 0 : (ref = attributes.industries) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return item.industryName;
        }).join(", ");
        industries = attributes === null || attributes === void 0 ? void 0 : (ref1 = attributes.industries) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
            return item.industryId;
        });
    }
    var company = {
        companyId: companyData.id,
        address: attributes.headquaterAddress,
        bannerDesktopUri: attributes.bannerDesktopUri,
        clpInfo: null,
        companyBenefits: attributes.benefits,
        companyLogoURL: attributes.companyLogo,
        companyName: attributes.companyName,
        companyProfile: attributes.companyProfile,
        companySizeId: attributes.companySize,
        contactEmail: attributes.companyContact,
        contactName: attributes.companyContact,
        jobImageURLs: attributes.companyImages,
        jobVideoURLs: attributes.companyVideos,
        profileBaseName: attributes.profileBaseName || "",
        website: attributes.website || "",
        whyWorkWithUs: attributes.whyWorkWithUs || "",
        industries: industries,
        industryNames: industryNames,
        companySizeName: attributes.companySize,
        isFollowed: Number(attributes.isFollowed) || 0,
        isReported: Number(attributes.isReported) || 0,
        totalFollow: attributes.followerCount || 0,
        totalJobs: attributes.totalJobs || 0,
        profilePublishedSiteMask: attributes.profilePublishedSiteMask || 0,
        profileSlug: attributes.profileSlug || "",
        url: attributes.url,
        geoloc: attributes.geoloc || null
    };
    return company;
};


/***/ }),

/***/ 10656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mk": function() { return /* binding */ DEFAULT_ERROR_CODE; },
/* harmony export */   "nL": function() { return /* binding */ getSpecialJob; },
/* harmony export */   "ok": function() { return /* binding */ getJobListFromCompany; },
/* harmony export */   "se": function() { return /* binding */ DEFAULT_SUCCESS_CODE; }
/* harmony export */ });
/* unused harmony exports DEFAULT_SUCCESS_MESSAGE, saveJob, unSaveJob */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39666);
/* harmony import */ var _helpers_encode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68325);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96306);





var API_GET_COMPANY_JOB_LIST = "".concat("https://ms.vietnamworks.com", "/job-search/v1.0/search");
var SAVE_JOB_URL = "".concat("https://ms.vietnamworks.com", "/api-gateway/v1.0/save-job");
var UNSAVE_JOB_URL = "".concat("https://ms.vietnamworks.com", "/api-gateway/v1.0/unsave-job");
var API_SPECIAL_JOB_URL = "".concat("https://ms.vietnamworks.com", "/api-gateway/v1.0/special-jobs");
var DEFAULT_SUCCESS_CODE = 200;
var DEFAULT_ERROR_CODE = 400;
var DEFAULT_SUCCESS_MESSAGE = "success";
var getJobListFromCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(accessToken, filter, page, query, userId, hitsPerPage, langCode) {
        var response, _tmp, ex, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(API_GET_COMPANY_JOB_LIST, (_tmp.method = "POST", _tmp.headers = {
                            "Accept-Language": langCode !== null && langCode !== void 0 ? langCode : _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* .ELanguage.VI */ .Df.VI,
                            Authorization: "Bearer ".concat((0,_helpers_encode__WEBPACK_IMPORTED_MODULE_0__/* .decrypt */ .pe)(accessToken)),
                            "Content-Type": "application/json"
                        }, _tmp.body = JSON.stringify({
                            query: query,
                            filter: filter,
                            ranges: [],
                            facets: "workingLocations.cityId",
                            order: [
                                {
                                    field: "approvedOn",
                                    value: "desc"
                                }
                            ],
                            hitsPerPage: hitsPerPage ? +hitsPerPage : 200,
                            page: page,
                            userId: userId,
                            retrieveFields: [
                                "address",
                                "benefits",
                                "jobTitle",
                                "isSalaryVisible",
                                "isShowLogo",
                                "companyLogo",
                                "userId",
                                "jobLevel",
                                "jobLevelId",
                                "jobLevelVI",
                                "jobId",
                                "companyId",
                                "approvedOn",
                                "isAnonymous",
                                "alias",
                                "expiredOn",
                                "industries",
                                "workingLocations",
                                "services",
                                "companyName",
                                "onlineOn",
                                "simpleServices",
                                "visibilityDisplay",
                                "isShowLogoInSearch",
                                "priorityOrder",
                                "skills",
                                "profilePublishedSiteMask",
                                "salary",
                                "salaryMin",
                                "salaryMax",
                                "prettySalary",
                                "jobDescription",
                                "jobRequirement"
                            ]
                        }), _tmp))
                    ];
                case 1:
                    response = _state.sent();
                    if (!(response.status === DEFAULT_SUCCESS_CODE)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    ex = _state.sent();
                    console.error("[getJobListFromCompany] Error while trying to get job list");
                    _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(ex);
                    return [
                        3,
                        5
                    ];
                case 5:
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.data = [], _tmp1.meta = {
                            code: DEFAULT_ERROR_CODE,
                            message: "ERROR"
                        }, _tmp1)
                    ];
            }
        });
    });
    return function getJobListFromCompany(accessToken, filter, page, query, userId, hitsPerPage, langCode) {
        return _ref.apply(this, arguments);
    };
}();
var saveJob = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(jobId, token, language) {
        var data, _tmp, responseSaveJob, _tmp1, ex, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    data = (_tmp.jobId = jobId, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        fetch(SAVE_JOB_URL, (_tmp1.method = "POST", _tmp1.mode = "cors", _tmp1.headers = {
                            "Accept-Language": language,
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat((0,_helpers_encode__WEBPACK_IMPORTED_MODULE_0__/* .decrypt */ .pe)(token))
                        }, _tmp1.body = JSON.stringify(data), _tmp1))
                    ];
                case 1:
                    responseSaveJob = _state.sent();
                    if (!(responseSaveJob.status === DEFAULT_SUCCESS_CODE)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        responseSaveJob.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    ex = _state.sent();
                    console.error("[SaveJobService] Error while trying to SAVE job or to convert the response to json");
                    _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(ex);
                    return [
                        3,
                        5
                    ];
                case 5:
                    _tmp2 = {};
                    return [
                        2,
                        (_tmp2.meta = {
                            code: DEFAULT_ERROR_CODE,
                            message: "ERROR"
                        }, _tmp2)
                    ];
            }
        });
    });
    return function saveJob(jobId, token, language) {
        return _ref.apply(this, arguments);
    };
}();
var unSaveJob = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(jobId, token, language) {
        var data, _tmp, responseUnSaveJob, _tmp1, ex, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    data = (_tmp.jobId = jobId, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        fetch(UNSAVE_JOB_URL, (_tmp1.method = "POST", _tmp1.mode = "cors", _tmp1.headers = {
                            "Accept-Language": language,
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat((0,_helpers_encode__WEBPACK_IMPORTED_MODULE_0__/* .decrypt */ .pe)(token))
                        }, _tmp1.body = JSON.stringify(data), _tmp1))
                    ];
                case 1:
                    responseUnSaveJob = _state.sent();
                    if (!(responseUnSaveJob.status === DEFAULT_SUCCESS_CODE)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        responseUnSaveJob.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    ex = _state.sent();
                    console.error("[SaveJobService] Error while trying to UN-SAVE job or to convert the response to json");
                    _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(ex);
                    return [
                        3,
                        5
                    ];
                case 5:
                    _tmp2 = {};
                    return [
                        2,
                        (_tmp2.meta = {
                            code: DEFAULT_ERROR_CODE,
                            message: "ERROR"
                        }, _tmp2)
                    ];
            }
        });
    });
    return function unSaveJob(jobId, token, language) {
        return _ref.apply(this, arguments);
    };
}();
var getSpecialJob = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(listJobId, token) {
        var decodeToken, responseSpecialJob, _tmp, ex, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    decodeToken = (0,_helpers_encode__WEBPACK_IMPORTED_MODULE_0__/* .decrypt */ .pe)(token);
                    _tmp = {};
                    return [
                        4,
                        fetch(API_SPECIAL_JOB_URL, (_tmp.method = "POST", _tmp.mode = "cors", _tmp.headers = {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(decodeToken)
                        }, _tmp.body = JSON.stringify({
                            jobId: listJobId
                        }), _tmp))
                    ];
                case 1:
                    responseSpecialJob = _state.sent();
                    if (!(responseSpecialJob.status === DEFAULT_SUCCESS_CODE)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        responseSpecialJob.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    ex = _state.sent();
                    console.error("GET Special Job ERROR", ex);
                    return [
                        3,
                        5
                    ];
                case 5:
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.status = {
                            code: DEFAULT_ERROR_CODE,
                            message: "ERROR"
                        }, _tmp1)
                    ];
            }
        });
    });
    return function getSpecialJob(listJobId, token) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);